
import Intro from './Content/AboutMe';
import './App.css';
import Experience from './Content/Experience';
import Products from './Content/Products';
import ContactMe from './Content/ContactMe';
import CodingProjects from './Content/CodingProjects';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { useEffect, useState } from "react";
// import { useSelector, useDispatch } from "react-redux";

function App() {


  const backendUrl = "https://m-a-server.onrender.com"; //"https://m-a-server.onrender.com";//"http://localhost:8080";//
  const [userInfo, setUserInfo] = useState({
    userAgent: '',
    language: '',
    userId:"",
  });

  function getOrCreateUserId() {
    let userId = localStorage.getItem('user_id');
    if (!userId) {
        userId = uuidv4(); // Generate a new UUID
        localStorage.setItem('user_id', userId); // Store it in local storage
    }
    return userId;
}

  useEffect(() => {
    const fetchData = () => {
      const user_id=getOrCreateUserId();
      // console.log("active");
      setUserInfo({
        userAgent: navigator.userAgent,
        language: navigator.language,
        userId: user_id,
        source: "productportfolio"
      });
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (userInfo.userAgent) {
      axios.post(`${backendUrl}/api/userInfo`,userInfo).then((data) => {
        console.log(data);
      })
    }
  }, [userInfo, backendUrl]);

  return (
    <div className='App'>

      <nav>
        <ul>
          <li><a href='#about-me'>About Me</a></li>
          <li><a href='#products'>Products</a></li>
          <li><a href='#experience'>Experience</a></li>
          <li><a href='#coding-projects'>Personal Projects</a></li>
          <li><a href='#contact'>Contact Details</a></li>
        </ul>
      </nav>


      <div id='about-me'></div>
      <div className='experience-div'>
        {/* <p className='exp-tile-intro'>About Me</p> */}
        {/* <div style={{ height: '32px' }}></div> */}
        <Intro />
      </div>


      <div id='products'></div>
      <div className='experience-div'>
        <p className='exp-tile-intro'>Products I've worked on</p>
        <Products />
      </div>


      <div id='experience'></div>
      <div className='experience-div'>
        <p className='exp-tile-intro'>My Experiences & Skills</p>
        <Experience />
      </div>


      <div id='coding-projects'></div>
      <div className='experience-div'>
        <p className='exp-tile-intro'>Personal Coding Projects</p>
        <CodingProjects />
      </div>


      <div className="experience-div" id='contact'>
        <p className='exp-tile-intro'>Contact Details:</p>
        <ContactMe />
      </div>


      <footer>
        <p>&copy; 2024 Designed & Developed by Rishabh Goel in React JS. All rights reserved</p>
      </footer>
    </div>
  );
}

export default App;
